"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import type { ComponentProps } from "react";

/**
 * Davnai's link (owner, 29 October: "majorly all the pages are still slow, even the tabs inside the pages"). Next.js
 * loads every link that scrolls into view ahead of time; a page of cards (Library, Projects, the bell) asked the server
 * for dozens of pages at once, and those competed with the page actually being opened. Here a link loads ahead only
 * when it's pointed at or touched (the main pages and a section's tabs are still loaded in the background by
 * WarmPages). A link that says prefetch itself keeps it.
 */
export default function AppLink({ prefetch, onMouseEnter, onTouchStart, onFocus, ...props }: ComponentProps<typeof Link>) {
  const router = useRouter();
  if (prefetch !== undefined && prefetch !== null) return <Link prefetch={prefetch} onMouseEnter={onMouseEnter} onTouchStart={onTouchStart} onFocus={onFocus} {...props} />;
  const href = typeof props.href === "string" ? props.href : props.href.pathname ? `${props.href.pathname}${typeof props.href.search === "string" ? props.href.search : ""}` : null;
  const ahead = () => {
    if (!href || !href.startsWith("/") || href.startsWith("/api/")) return;
    try {
      router.prefetch(href);
    } catch {
      // it simply loads on click
    }
  };
  return (
    <Link
      prefetch={false}
      onMouseEnter={(e) => { ahead(); onMouseEnter?.(e); }}
      onTouchStart={(e) => { ahead(); onTouchStart?.(e); }}
      onFocus={(e) => { ahead(); onFocus?.(e); }}
      {...props}
    />
  );
}
